<template>
  <vue-modaltor
    :visible="show"
    @hide="hiddenModal"
    :default-width="'45%'"
    :bg-overlay="'rgba(0, 0, 0, 0.7)'"
    :resize-width="{1200:'75%',992:'80%',768:'100%'}"
  >
    <app-loading :isFull="true" v-if="isLoading"/>

    <div class="box-pay">
      <template v-if="!basketList.length">
        <template v-if="courseDetail && courseDetail.hasOwnProperty('course_price')">
        <p class="font-16">
          {{ courseDetail.course_title }}
        </p>
        <p class="font-16">
          <span class="font-weight-bold">مبلغ قابل پرداخت :</span>
          <template v-if="!item.course_price">
            {{ courseDetail.course_price | currency }}
          </template>
          <template v-if="item.course_price || item.course_price === 0">
            {{ item.course_price | currency }}
          </template>
        </p>
      </template>
      </template>
      <p class="font-16">
        <span class="font-weight-bold">پرداخت از طریق :</span>
      </p>
      <div class="d-flex flex-column align-items-center   justify-content-center box-pay-list">
        <div class="d-flex align-items-center w-100 mb-4">
          <p class="font-16 ml-4">
            درگاه مستقیم بانک ملی :
          </p>
          <img
            :class="{'pointer-null':isClicked}"
            src="/static/img/bank-meli.png"
            alt="bank-meli"
            class="pointer shadow-sm mr-3"
            @click="getPayment('sadad')"
          />
        </div>
        <div class="d-flex align-items-center w-100">
          <p class="font-16 ml-4">
            در گاه مستقیم آیدی پی :
          </p>
          <img
            src="/static/img/idpay.svg"
            class="pointer shadow-sm "
            :class="{'pointer-null':isClicked}"
            width="110px"
            @click="getPayment('idpay')"
            alt="idpay"
          >
        </div>
      </div>
      <div class="my-4 text-center" v-if="false">
        <p>در صورت مشکل در پرداخت از فرم زیر استفاده نمایید.</p>
        <a
          class="align-items-center
          justify-content-center
          box-pay-form-link
           d-flex mb-1
          bttn-minimal
          bttn-sm
           bttn-royal"

          v-ripple
          title="فرم پرداخت"
          href="https://pay.madia.ir"
          target="_blank"
        >
          <i class="flaticon-list-2 ml-2 text-light"></i>
          <span class="font-12 ">فرم پرداخت دستی</span>
        </a>
      </div>
      <div
        v-if="isClicked"
        class="font-14 text-center text-info"
      >در حال انتقال به بانک لطفا صبر کنید ...
      </div>
    </div>
  </vue-modaltor>
</template>

<script>
export default {
  name: "modal-bill",
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isClicked: false,
      isLoading: false
    };
  },
  computed: {
    basketList() {
      return this.$store.state.basket.basketList;
    },
    offerCode() {
      return this.$store.state.basket.offerCode || undefined;
    },
    courseDetail() {
      return this.$store.state.courses.courseDetail;
    },
    item() {
      return this.$store.state.basket.singleItem;
    }
  },
  methods: {
    hiddenModal() {
      this.$emit("hiddenModal");
    },

    async getPayment(gateway) {
      let course = [];
      let code = "";
      if (this.courseDetail && this.courseDetail.hasOwnProperty("id")) {
        course = [this.courseDetail.id];
      } else {
        course = this.basketList.map(e => e.id);
      }
      if (this.offerCode) {
        code = this.offerCode;
      }
      let data = {
        code,
        course,
        gateway
      };
      if (this.isClicked) return;
      this.isClicked = true;
      this.isLoading = true;
      try {
        await this.$store.dispatch("basket/postPrebill", data);
        this.isLoading = false;
        this.$store.commit("notifications/success", {
          message: "انتقال به بانک",
          title: "لطفا صبور باشید درحال انتقال صفحه به بانک هستیم."
        });
      } catch (error) {
        this.$store.commit("notifications/warn", {
          message: error.message,
          title: " خطا " + error.err
        });
      }
    }
  }
};
</script>


<style>
@media screen and (min-width: 992px) {
  .box-pay-list {
    width: 50%;
    margin: 0 auto;
  }
  .box-pay-form-link {
    width: 25%;
    margin: 0 auto;
  }
}
@media screen and (max-width: 992px) {
  .box-pay p {
    font-size: 14px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/min-component/modal-bill.vue